var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Herb_Polski 1",
    clipPath: "url(#clip0_61122_4991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2161",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333984 0L0.613802 19.1265C0.613802 19.1265 0.638941 20.8481 2.46537 21.9915C2.97559 22.3109 3.78735 22.5636 5.03389 22.5473C5.41385 22.5421 7.58802 22.5316 8.68312 22.5604C9.48265 22.5815 10.8136 23.1113 10.907 24H11.0947C11.1751 22.9708 12.5068 22.5827 13.3185 22.5604C14.4084 22.5306 16.5874 22.5423 16.9674 22.5473C18.2139 22.5637 19.0257 22.3109 19.5359 21.9915C21.3624 20.8481 21.3875 19.1265 21.3875 19.1265L21.6673 0H0.333984Z",
    fill: "#DC143C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3360",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24805 1.26917C9.59569 1.84946 9.73511 2.3986 9.92726 2.92307C10.2455 2.88173 10.6096 2.96448 10.9702 2.98871C11.3818 3.06591 11.7074 3.09932 12.0131 3.05439C12.2008 2.22796 12.3633 1.81509 12.7369 1.23368C12.5711 1.34149 12.2183 1.38556 12.0799 1.58149C11.8726 1.40511 11.7081 1.51552 11.6049 1.70217C11.64 1.55319 11.5935 1.4269 11.3896 1.41469C11.5105 1.19791 11.3243 1.0904 11.1298 1.18752C11.1244 0.998725 10.9666 0.997153 10.9553 0.896484C10.9292 1.01308 10.7909 0.955402 10.8106 1.23723C10.6531 1.11622 10.4992 1.19507 10.5582 1.40759C10.3671 1.40677 10.3138 1.55723 10.3318 1.74474C10.2008 1.454 9.9546 1.54279 9.86787 1.64536C9.71421 1.35585 9.5981 1.53866 9.24805 1.26917Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3358",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3154 2.74809C12.094 3.11203 11.9991 3.13732 11.0281 2.99452C10.26 2.92125 9.56814 2.71385 9.53639 3.37946C9.79044 3.4083 10.16 3.43466 10.3209 3.95389L9.85089 4.33738C9.51891 4.38735 8.99532 4.81209 8.64944 4.41713C8.5545 4.78853 8.91107 4.89304 9.28309 4.87815C9.54377 4.85256 9.62702 4.78565 10.1137 4.69364L10.2427 4.82629C10.9777 4.88446 11.3584 5.88974 10.1662 6.47957C10.1201 6.61609 10.1963 6.77988 10.3096 6.79928C9.96299 7.26804 9.39427 7.85287 9.19022 7.46699C9.14269 7.50969 9.0088 7.82866 9.26832 8.00491C9.07116 8.23707 8.99497 8.51176 9.00553 8.82903C8.21977 8.71165 7.70222 8.58429 7.87836 7.88159C8.7144 7.91851 8.94094 6.95304 8.81809 6.46364C8.33226 4.50877 5.69508 2.94089 3.77563 2.88977C3.8824 3.42167 4.22558 3.80544 4.61636 4.15939C4.10735 3.92245 3.51665 3.69273 2.89796 3.8132C2.96947 4.23337 3.20771 4.72075 4.21024 5.51578C3.48765 5.10548 2.82116 4.70491 2.58641 4.3786C2.48212 4.51314 2.42334 5.06112 3.04023 5.46108C2.84433 5.38636 1.87612 5.393 1.58337 5.59814C1.76024 5.98299 2.56823 6.65566 3.23126 6.86306C2.60256 6.77563 2.01325 6.53337 1.47361 6.09587C1.39389 6.16427 1.47667 6.87647 2.14695 7.15999C1.92985 7.17381 1.18929 7.37247 0.998047 7.60062C1.38443 8.09386 2.3724 8.52834 2.86335 8.53012C2.19367 8.61363 1.46232 8.48486 1.15826 8.39327C1.16501 8.55694 1.02101 9.21425 2.85385 9.10575C2.19995 9.40119 1.21301 10.0162 1.05546 10.5584C1.69074 10.8274 2.82995 10.6058 3.41912 10.4291C1.67688 11.4445 1.40501 11.5488 1.08185 11.4807C1.50368 12.3335 2.52017 11.7573 3.39843 11.2796C2.3187 12.6611 2.14314 13.3654 2.16616 14.3442C3.03567 14.2442 4.29433 13.0531 4.96506 12.0377C4.18781 13.5665 3.72518 14.7956 2.8777 15.1572C3.84324 15.523 4.67137 14.3643 5.25318 13.1354C5.03035 13.9133 4.93817 15.5623 5.22278 15.9656C6.09572 15.4001 6.75698 14.1444 7.20017 12.7047C7.049 13.4141 6.93712 14.1234 6.6653 14.8329C7.22642 14.9349 7.51324 13.9721 7.70254 13.4081C7.72001 13.4376 7.74083 13.4625 7.79499 13.5106C8.50389 13.0188 8.72946 11.8772 8.77925 11.4302C9.4256 11.6058 9.71 11.3817 9.87559 11.2667C10.0172 11.4542 10.0261 11.7466 10.066 11.7866C9.36297 11.2406 8.60894 11.7879 8.57809 12.6974C8.50192 13.0769 8.28985 13.5159 7.75911 13.8555C7.79228 13.8968 7.86643 13.9136 7.96258 13.9119C7.87012 14.064 7.78625 14.1955 7.6295 14.3333C7.67001 14.3558 7.72066 14.3588 7.7686 14.367C7.65064 14.5554 7.45371 14.7333 7.25695 14.824C7.30416 14.8673 7.33103 14.8818 7.47415 14.9189C7.34302 15.0854 7.12905 15.2356 6.92725 15.3167C7.31231 15.5354 7.6065 15.5635 7.84523 15.5426C7.84565 15.5425 7.84607 15.5426 7.84649 15.5426C7.69414 15.8308 7.44843 15.9767 7.2084 16.1061C7.28307 16.1732 7.37289 16.1877 7.44755 16.1677C7.23058 16.3832 7.00137 16.5531 6.79448 16.6144C6.83215 16.6414 6.85856 16.6784 6.99183 16.6689C6.84376 16.8436 6.66415 17.0142 6.34636 17.0935C6.40924 17.2092 6.53849 17.1914 6.6501 17.1953C6.5633 17.374 6.29145 17.434 6.01623 17.4894C6.22363 17.5454 6.36465 17.652 6.24124 17.6242C6.15752 17.7207 6.07536 17.7707 5.89592 17.7964C5.71153 17.8228 5.05148 17.5954 4.78543 17.6831C4.71011 17.5397 4.52784 17.4409 4.33562 17.4409C4.09001 17.4409 3.84859 17.5906 3.83727 17.7998C3.79922 17.7746 3.63894 17.7544 3.66334 17.9362C3.72117 18.0433 3.72399 18.1292 4.07747 18.2594C4.13505 18.2839 4.20513 18.2967 4.29003 18.2933C4.41593 18.2882 4.55679 18.2278 4.66216 18.1403L4.66005 18.1439C4.83605 18.1751 5.02983 18.2033 5.13688 18.2461C4.85841 18.2673 4.76264 18.4143 4.6039 18.52C4.53707 18.5168 4.4818 18.501 4.42132 18.4917L4.42322 18.4937C4.38693 18.485 4.35028 18.4812 4.31451 18.483C4.11572 18.4933 3.91532 18.7075 3.89383 18.9503C3.88948 18.9995 3.90221 19.0466 3.92718 19.0896L3.92423 19.1309C3.86624 19.1994 3.88921 19.2538 3.94576 19.2932C4.18844 19.3854 4.3332 19.3287 4.42048 19.3118C4.64068 19.2863 4.8249 19.1127 4.8249 18.9196C4.8249 18.9192 4.8249 18.9187 4.8249 18.9182L4.82955 18.923C5.09004 18.8713 5.34688 18.8021 5.48959 18.7016C5.49694 18.7168 5.50123 18.7333 5.49803 18.7535C5.40739 18.8049 5.25832 18.8864 5.17951 19.1378C5.156 19.1357 5.13358 19.1346 5.11239 19.1346C4.81444 19.1342 4.7409 19.3309 4.74617 19.4916C4.75131 19.6483 4.81086 19.7493 4.89582 19.8102C4.87779 19.9077 4.89031 19.9893 4.99588 20.0219C5.35157 20.0752 5.43712 19.8993 5.50859 19.9036C5.50462 19.8589 5.51419 19.8272 5.52737 19.7989C5.63647 19.7504 5.71046 19.7108 5.72072 19.5148C5.73008 19.3931 5.70841 19.3186 5.66668 19.271L5.67618 19.2736C5.67622 19.274 5.67635 19.2743 5.67639 19.2747C5.67673 19.2743 5.6771 19.2741 5.67745 19.2739L5.68041 19.2747L5.67998 19.2718C6.00575 19.0058 6.21434 18.7959 6.35501 18.6184C6.48037 18.646 6.76149 18.6397 6.89981 18.5954L6.89432 18.6431C6.76382 18.7618 6.85252 19.0453 7.02477 19.0391C7.01735 19.0657 7.0187 19.0898 7.02477 19.1164C7.13655 19.1823 7.34312 19.136 7.50075 19.1697C7.58158 19.1606 7.61997 19.1087 7.59953 19.0028L7.59679 19.0012C7.72324 18.9295 7.80807 18.8003 7.79183 18.637C7.79183 18.4113 7.60752 18.231 7.38022 18.2168L7.38149 18.2157C7.13822 18.1906 6.90479 18.3584 6.95574 17.9961C7.62168 17.242 8.53078 16.1028 8.77925 15.9644C8.75942 15.9397 8.74605 15.9073 8.73471 15.8758C8.83337 16.1256 9.20656 16.3889 9.59908 16.3662C9.52842 16.2376 9.44998 16.1234 9.42199 15.7797C9.48066 15.8608 9.58076 15.8988 9.70314 15.9228C9.51964 15.1199 9.79343 14.4593 10.3573 13.8555C10.3125 14.6324 10.2099 15.4142 9.71665 16.2062C9.97045 16.2822 10.3021 16.0348 10.3478 15.8879C10.4018 16.5874 9.70857 17.4879 9.16637 17.0562C8.82599 17.7718 9.63325 18.119 10.1424 17.7037C10.0563 18.1366 9.70255 18.3911 9.31687 18.4904C8.93119 18.5898 8.52935 18.4331 8.78579 17.8427C8.73144 17.812 7.95781 17.7933 7.93599 18.5999C7.95906 19.0659 8.28816 19.2413 8.31783 19.2494C7.21473 20.0496 8.32608 20.9415 9.23624 20.7682C9.95797 20.6618 10.3681 20.1026 10.6296 19.6971C10.5505 19.9888 10.2242 20.9255 11.0557 21.94C11.8797 20.7095 11.5312 19.8805 11.5112 19.749C12.1589 20.7036 12.7975 20.7723 13.175 20.7487C13.8201 20.7586 14.7336 19.7891 13.5722 19.1688C14.1665 18.8983 14.2057 17.7743 13.3685 17.7166C13.541 18.162 13.177 18.4311 12.7756 18.3964C12.3742 18.3617 12.0042 18.1403 11.8618 17.6417C12.6522 18.0052 13.0191 17.2901 12.7501 16.9019C12.0755 17.4353 11.7565 16.5797 11.666 16.0706C11.8383 16.196 11.9874 16.2395 12.2772 16.1985C11.7285 15.5238 11.6004 14.6187 11.5513 13.7687C11.9248 14.3365 12.2935 15.0315 12.2815 15.7123C12.3679 15.6717 12.4464 15.6607 12.6021 15.3627C12.6161 15.8719 12.5554 15.9408 12.3752 16.1539C12.6702 16.2725 13.0577 16.0444 13.2421 15.7417C13.2427 15.7409 13.2431 15.7401 13.2438 15.7393C13.817 16.4794 14.4358 17.239 15.0377 17.8264C15.1683 17.9567 15.2134 18.087 14.9717 18.1328C14.1981 17.8597 14.1169 18.6333 14.4378 18.7379C14.4125 18.8078 14.4054 18.8803 14.4275 18.9567C14.5797 19.0016 14.8909 18.8809 14.9742 18.8766C15.0129 18.8432 15.0133 18.7731 15.0122 18.7016C15.0899 18.6979 15.143 18.659 15.18 18.597C15.3309 18.6247 15.4772 18.6432 15.668 18.4925L16.24 19.0419C16.2697 19.0582 16.2097 19.1169 16.2907 19.1244C16.2271 19.4893 16.3722 19.5308 16.4967 19.6228C16.4712 19.9719 17.0175 19.7706 17.0711 19.7905C17.1289 19.7579 17.1339 19.7202 17.1245 19.6811C17.188 19.6174 17.1583 19.5851 17.1373 19.54C17.411 19.1411 17.0228 18.8369 16.8093 18.8717C16.5822 18.6334 16.4184 18.5331 16.235 18.3903C16.6104 18.5258 17.1895 18.6789 17.3558 18.7962C17.4191 19.2034 17.7925 19.0352 18.0676 19.0492C18.153 18.9343 18.1071 18.8987 18.0676 18.8594C18.4296 18.4128 17.6657 18.0463 17.3406 18.3102C17.1477 18.14 16.9807 18.1102 16.8068 18.0428C16.8794 17.9729 17.0331 17.9184 17.3788 17.897C17.5339 17.9952 17.6888 18.0298 17.8438 17.9212C17.9105 18.0609 18.0432 18.0247 18.0904 17.999C18.2038 17.8739 18.207 17.6841 18.2379 17.5105C18.207 17.4476 18.1577 17.4066 18.0726 17.4084C17.8378 17.0243 17.3843 17.2578 17.3583 17.4302C16.9674 17.4608 16.6198 17.5085 16.2069 17.6661C16.0707 17.7053 15.9411 17.5645 15.8257 17.4837C15.9302 17.4437 16.0213 17.3982 16.0188 17.3135C15.8516 17.2978 15.6884 17.309 15.4951 17.1191L15.546 16.9879C15.3969 16.9442 15.2366 16.8403 15.0403 16.5455C15.0814 16.522 15.1203 16.483 15.1547 16.4143C14.9316 16.365 14.7489 16.252 14.6004 16.0861C14.6536 16.0612 14.7041 16.0179 14.7505 15.9476C14.5424 15.8275 14.3421 15.723 13.9433 15.226C13.9418 15.2236 13.9403 15.2209 13.9389 15.2188C14.3588 15.2858 14.7974 15.2463 15.057 15.0658C14.8506 15.0108 14.4864 14.8959 14.3239 14.5955C14.4045 14.5892 14.4488 14.5741 14.4989 14.5606C14.1839 14.3617 14.1005 14.2542 14.0206 14.0931C14.0868 14.0994 14.1816 14.0706 14.2133 14.0265C14.0102 13.9391 13.9211 13.8183 13.8487 13.6866C13.9322 13.6882 14.02 13.7038 14.0875 13.6545C13.2852 13.3084 13.3968 11.5147 12.5356 11.5093C12.1523 11.5393 12.0827 11.6187 11.8851 11.7152C11.943 11.5617 12.0412 11.4179 12.1436 11.2751C12.614 11.4852 12.9868 11.3668 13.1131 11.2614C13.1774 11.9823 13.4191 12.7559 13.9425 13.143C14.0322 13.0947 14.1399 13.0326 14.2057 12.9632C14.299 13.6329 14.5605 14.5131 15.1477 14.44C14.8771 13.7952 14.8814 13.1473 14.8516 12.503C15.0977 14.3938 15.7046 15.4967 16.2063 15.8273C16.4374 15.5354 16.6097 14.1552 16.4976 13.3263C16.9908 14.18 17.5382 14.9705 17.9971 14.9662C18.205 14.9643 18.4358 14.8015 18.5752 14.7604C17.8559 14.4828 17.3676 13.2164 16.9258 12.4279C17.7548 13.6691 18.7387 14.2282 19.2027 14.3123C19.2194 13.9284 19.3082 12.8544 18.2761 11.3664C20.1206 12.3001 20.5125 11.6971 20.6206 11.3755C19.7882 11.6528 18.6656 10.6297 17.9137 10.3045L17.9036 10.276C19.0037 10.7561 20.0832 10.9216 20.755 10.5168C20.1808 9.66945 19.6246 9.36076 19.0202 9.14305C20.2145 9.26983 20.606 8.88131 20.6307 8.45598C20.1948 8.59683 19.7916 8.61882 19.272 8.53936C20.415 8.31913 20.6211 7.85543 20.6098 7.80906C20.317 7.59155 19.7642 7.3466 19.2648 7.30163C20.6429 6.82811 20.2049 6.3817 20.1537 6.24155C19.7251 6.62566 18.9782 6.89969 18.8462 6.88826C19.4895 6.56749 20.0473 5.72826 20.0112 5.63341C19.6898 5.47527 19.0242 5.48303 18.7567 5.56035C19.0244 5.27954 19.3758 4.79893 19.0516 4.39914C18.7398 4.82055 18.4433 5.04466 18.1471 5.26465C18.4159 4.93954 18.7281 4.56657 18.8351 3.80309C18.4326 3.85351 18.0677 3.81576 17.5454 4.14562C17.8451 3.78754 18.0296 3.43516 18.0661 3.00843C16.2659 3.12923 14.1617 4.0317 13.1463 6.28173C12.8515 6.94273 13.0815 8.06774 14.0079 7.93947C14.154 8.50714 13.7613 8.85403 12.9078 8.82899C12.8897 8.63896 12.952 8.26244 12.7072 8.06419C12.9145 8.05136 12.9552 7.94938 12.9985 7.86277C12.4414 7.73982 12.5316 7.56304 12.6355 6.61658C12.7087 6.64567 12.7923 6.62884 12.8556 6.57277C12.6254 6.36982 12.7015 5.99442 12.8176 4.81168C12.8409 4.29621 12.7299 4.03818 12.6116 3.94923C12.6829 3.91461 12.7297 3.85858 12.6929 3.73002C12.9505 3.68675 12.8414 3.38606 12.7353 3.28857C12.6836 3.42261 12.4627 3.47208 12.2534 3.32351C12.5065 3.21319 12.5088 2.9387 12.3155 2.74805L12.3154 2.74809ZM13.3567 15.4586C13.3652 15.4685 13.3741 15.4778 13.3831 15.4868C13.3741 15.4783 13.3652 15.4694 13.3563 15.4602C13.3564 15.4597 13.3565 15.4591 13.3567 15.4586L13.3567 15.4586ZM8.0886 15.4951C8.06368 15.5844 8.10798 15.8283 8.1133 15.9906C8.19861 16.0308 8.34922 15.9892 8.52194 15.9263C8.51257 15.9302 8.50339 15.9339 8.49408 15.9378C8.36413 15.9838 8.20931 16.0309 8.11203 15.9935L8.08163 15.6304C8.0752 15.5894 8.07582 15.5451 8.08776 15.4953C8.08805 15.4953 8.08831 15.4952 8.0886 15.4951L8.0886 15.4951ZM8.02507 15.5121C8.01078 15.5161 7.9962 15.5196 7.98116 15.5226C7.99566 15.5193 8.01016 15.5159 8.02507 15.5121ZM13.4656 15.5565C13.6559 15.6895 13.8908 15.6932 13.9775 15.6734C13.9824 15.663 13.9867 15.6525 13.9906 15.6421C13.9875 15.6539 13.984 15.6657 13.9802 15.6778C13.801 15.7039 13.628 15.6757 13.4656 15.5565ZM6.90804 18.5926C6.90802 18.5927 6.90805 18.5929 6.90804 18.5931L6.90761 18.5929C6.90775 18.5928 6.90789 18.5928 6.90804 18.5926ZM11.7888 18.7947C11.9677 18.9742 12.6577 19.4624 13.458 19.2264C13.5245 19.6589 13.1402 19.8218 12.8368 19.7627C12.5402 19.705 12.0942 19.4787 11.7888 18.7947ZM10.1985 18.9053C9.93885 19.3778 9.50841 19.7774 9.12521 19.8735C8.74201 19.9697 8.38496 19.7875 8.52406 19.3118C9.35155 19.5767 10.0239 19.1082 10.1985 18.9053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3362",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38006 10.1487C6.10067 9.83308 6.14161 9.63355 6.1504 9.52216C5.84214 9.29966 5.92317 9.21178 5.87009 9.12171C5.97704 9.30197 6.08398 9.42137 6.19093 9.4382C6.39469 9.61676 6.59845 9.67679 6.80221 9.79347C5.55614 9.14213 5.89955 8.34313 5.914 8.11411C5.71928 8.1203 5.57627 8.08201 5.47158 8.01076C5.50745 7.6878 5.68473 7.42528 6.06259 7.24861C6.01531 7.26429 5.96803 7.28578 5.92075 7.29383C5.87643 7.285 5.76888 7.01876 5.90386 6.8449C5.9814 6.79795 6.19111 6.78141 6.4037 6.86108C6.52941 6.61914 6.69221 6.40377 7.03187 6.31528C7.11575 6.39816 7.2575 6.64517 7.15683 7.07421C7.2962 7.1236 7.43248 7.18573 7.54521 7.34548C7.51031 7.48184 7.47542 7.52025 7.44052 7.5554C7.98542 7.56085 8.03847 6.82956 7.43097 6.75261C7.52928 6.0641 6.60613 5.65326 6.20444 6.50258C5.46523 6.31301 5.26682 6.86368 5.54587 7.29383C5.45569 7.35691 4.72437 7.87267 5.42092 8.61144C5.41952 8.97533 5.5162 9.32887 6.0322 9.63843C6.18045 10.0556 6.2743 10.0566 6.38006 10.1487Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3364",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.543 6.30429L15.6413 6.12581C16.3067 6.02654 16.7088 6.45224 16.4484 6.9555C16.9856 7.39481 16.6901 7.96549 16.3652 8.0794C16.7531 7.80694 16.5397 7.72277 16.4737 7.72727C16.4944 7.71819 16.5269 7.70095 16.5544 7.67904C16.533 7.43896 16.4343 7.21171 16.0474 6.93863C16.2385 6.73622 16.2193 6.54396 16.1937 6.40801C15.9807 6.35499 15.7921 6.37179 15.6262 6.45385L15.543 6.30429Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3366",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6224 7.54234C14.6532 7.44299 14.6814 7.2834 14.8696 7.13232C14.8107 7.17345 14.7453 7.22387 14.6729 7.28427C14.4309 7.19045 14.2758 6.97855 14.2391 6.85016C14.387 6.66726 14.7393 6.69379 14.7889 6.70543C14.6865 6.33654 14.8192 6.06259 14.915 5.95775C15.2339 5.98589 15.3991 6.14292 15.5279 6.28336L15.6237 6.11936C15.5366 5.86051 15.2696 5.66556 14.9554 5.72733C14.6929 5.75402 14.3948 5.97211 14.514 6.48354C13.7222 6.78864 14.0593 7.51453 14.6224 7.54234Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3368",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8988 8.83743C12.8697 9.11658 12.8123 9.32015 12.75 9.51035C13.826 9.35592 15.4198 9.09088 15.2041 7.95951C15.0082 8.09587 14.8123 8.12078 14.6164 8.12351C14.583 7.9624 14.5643 7.79114 14.624 7.56641C14.4462 7.79666 14.2364 7.88363 14.0187 7.93542C14.9924 8.351 13.6067 9.08581 13.0274 8.83743H12.8988Z",
    fill: "#F1EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3370",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0144 9.26074C9.04538 9.58107 9.14982 9.97083 9.2527 10.3317C9.18419 10.2287 8.97626 9.60112 9.0144 9.26074Z",
    fill: "#E8E6EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3372",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2148 9.03219C11.9546 10.0178 13.1016 9.92211 12.2968 8.91113C13.0792 9.36914 12.5662 10.054 12.5269 10.2072C12.4041 9.67861 11.92 9.54518 12.2148 9.03219Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3374",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03124 6.33301L6.6426 7.42469C6.54648 7.38566 6.45701 7.34881 6.33203 7.21015C6.33499 6.83198 6.685 6.36052 7.03124 6.33301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3376",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34062 8.45924L6.64062 7.42499C6.74999 7.42264 6.87762 7.42544 7.0297 7.39062C7.23571 7.57525 7.46491 8.0552 7.34062 8.45924Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3378",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.14183 7.08203C7.35272 7.13803 7.49898 7.26894 7.52318 7.35069L7.0293 7.39449C7.07653 7.29696 7.11197 7.18884 7.14183 7.08203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3380",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91811 7.28992C5.82594 7.16248 5.82639 6.90128 5.92184 6.84766L6.3337 7.21151C6.22409 7.2358 6.02474 7.24675 5.91811 7.28992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3382",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48438 8.00004L6.63827 7.43056C6.66249 7.41637 6.47428 7.24568 6.3315 7.2116C6.02342 7.17418 5.51067 7.54294 5.48438 8.00004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3384",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44245 8.00098C5.84689 9.63152 8.41241 9.88415 9.0963 9.93283L9.01379 9.52417C7.77312 9.4714 6.61597 9.20966 6.78726 8.318C6.56312 8.18387 6.51509 8.12347 6.44245 8.00098Z",
    fill: "url(#paint0_linear_61122_4991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3386",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44522 7.99707C6.30798 8.06156 6.11125 8.09023 5.92064 8.11828C5.42686 10.096 8.63137 10.2521 9.24496 10.3249C9.14858 10.1422 9.12437 10.0456 9.09674 9.92637C7.47049 9.82566 5.9666 9.24318 6.44522 7.99707Z",
    fill: "url(#paint1_linear_61122_4991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3388",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9199 5.9668C15.0997 6.32128 15.292 6.73852 15.4277 7.13522C15.5052 7.02675 15.581 6.918 15.7362 6.79302C15.6512 6.42071 15.457 6.02675 14.9199 5.9668Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3390",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9216 5.96387C15.1028 6.32714 15.3107 6.76208 15.4304 7.13373L14.9933 7.07349C14.7344 6.80437 14.6724 6.26826 14.9216 5.96387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3392",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 6.84782C14.3633 6.72391 14.6049 6.68468 14.7997 6.7167C14.8439 6.81955 14.915 6.96505 14.9945 7.07638L14.25 6.84782Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3395",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1821 6.41799L15.7363 6.79865L16.0258 6.94369C16.259 6.75214 16.1947 6.41526 16.1821 6.41799Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3397",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7364 6.79199C15.6649 6.80614 15.4161 7.13443 15.4324 7.1315L16.5453 7.67421C16.5495 7.49003 16.3724 7.03801 15.7364 6.79199Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3399",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.429 7.12793L14.627 8.11849C15.1401 8.09724 15.346 7.87915 15.5256 7.60813L15.429 7.12793Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3401",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1822 6.41728C16.0103 6.36242 15.7832 6.37986 15.625 6.46388C15.6776 6.57042 15.7133 6.70182 15.7386 6.79684L16.1822 6.41728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3403",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4277 7.12891L16.5462 7.67338C16.3416 7.8347 15.695 7.68424 15.5216 7.61179L15.4277 7.12891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3405",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4296 7.13189L14.9914 7.07227C14.5051 7.26713 14.591 8.06113 14.6278 8.1191L15.4296 7.13189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3407",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9873 7.07519L14.25 6.84766C14.2862 7.01789 14.5034 7.21015 14.6683 7.27468C14.7034 7.2441 14.866 7.10134 14.9873 7.07519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3409",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5378 7.61133C15.4012 7.80363 15.3589 7.85458 15.2079 7.95249C15.4687 9.09739 13.7487 9.38359 12.7543 9.51719C12.7446 9.67479 12.6924 9.80785 12.6445 9.92894C12.8238 9.91693 16.3542 9.85212 15.5378 7.61133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3411",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5572 7.62598C16.0328 9.29147 14.4775 9.76626 12.6456 9.92502C12.601 10.0287 12.5582 10.141 12.5137 10.2567C15.0002 10.0906 16.3013 9.322 15.9621 7.71963C15.8024 7.69628 15.6768 7.66212 15.5572 7.62598Z",
    fill: "url(#paint2_linear_61122_4991)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3413",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94944 19.2946C4.14918 19.3828 4.39615 19.3228 4.52948 19.2861C4.60111 19.3514 4.50746 19.6086 4.71945 19.7958C4.59836 19.8465 3.93541 19.6514 3.94944 19.2946Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3415",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66377 17.9258C3.74671 18.179 3.98127 18.2061 4.07698 18.2587C4.07442 18.3544 3.81784 18.3497 3.80855 18.6961C3.62923 18.6806 3.37969 18.2799 3.66377 17.9258Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3417",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99823 20.0187C5.32151 20.0709 5.43861 19.9048 5.51107 19.8955C5.54868 19.9968 5.69316 20.1288 5.83353 20.1978C5.76794 20.4251 4.9842 20.3754 4.99823 20.0187Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3419",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49008 19.172C7.47117 19.1334 7.09983 19.1764 7.03275 19.1191C6.98618 19.1742 6.97241 19.3558 6.83203 19.4249C6.92165 19.5802 7.54235 19.5288 7.49008 19.172Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3422",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19867 16.0107C8.25412 16.0045 8.30766 15.997 8.35305 15.9843C8.13475 16.2353 7.77111 16.6732 7.40578 17.0421C7.03945 17.412 6.70609 17.7768 6.83268 18.1076C6.57872 17.8662 6.80422 17.6305 7.14792 17.2419C7.52088 16.8202 7.9416 16.3341 8.19867 16.0107ZM7.73909 18.6885C7.73909 18.8605 7.58955 19.0195 7.22912 19.0034C7.63534 18.5771 6.81413 18.5508 7.0096 18.3769C7.55445 18.0503 7.77962 18.5552 7.73909 18.6885ZM7.3511 19.0634C7.46879 19.0871 7.54284 18.9471 7.56878 19.0184C7.6195 19.1593 7.35348 19.1852 7.3511 19.0634ZM4.60183 17.5876C4.51908 17.5845 4.54263 17.9049 4.05134 17.892C4.04254 17.8898 3.99643 17.8924 3.97049 17.9364C3.91079 18.0436 4.11134 18.2622 4.29408 18.2493C4.45351 18.2381 4.58674 18.1507 4.66937 18.042C4.70683 18.0219 4.96762 17.8836 4.9461 17.9433C4.64006 18.0862 4.71642 18.1766 5.20171 18.2103C5.50776 18.1669 5.76747 17.9136 5.87738 17.8609C5.56465 17.9128 4.89862 17.7137 4.7441 17.7126C4.72218 17.6582 4.67739 17.6136 4.60584 17.5881C4.60447 17.5878 4.60314 17.5877 4.60183 17.5876V17.5876ZM4.05271 19.2243C4.0447 19.2511 4.02819 19.2699 4.00702 19.2842C4.09368 19.3369 4.32668 19.3228 4.35252 19.3047C4.32683 19.3041 4.13531 19.293 4.05271 19.2243ZM6.34091 17.8957C5.92462 18.09 5.63833 18.792 4.605 18.6998C4.57922 18.7861 4.52185 18.8035 4.46864 18.8298C4.25316 18.827 4.00471 18.8762 4.00722 19.005C4.01026 19.161 4.26124 19.2585 4.42938 19.2391C4.59958 19.2195 4.77708 19.0642 4.77724 18.9083C4.77724 18.9082 4.77724 18.9082 4.77724 18.9081C4.78282 18.8954 4.79151 18.8853 4.80932 18.8855C5.95301 18.6492 6.12857 18.0876 6.34091 17.8957V17.8957ZM6.52328 17.915C6.47793 18.1806 5.57688 18.9727 5.53501 19.2321C5.48717 19.1967 5.41816 19.1712 5.27411 19.1784C5.35788 19.575 5.01148 19.6965 4.91908 19.6285C4.91851 19.8077 5.19139 19.8822 5.36826 19.8497C5.57616 19.8115 5.75016 19.5073 5.62957 19.3221C5.65705 18.994 6.10818 18.8985 6.297 18.477C6.46344 18.4753 6.48872 18.2289 6.69552 18.1831C6.65207 18.0553 6.48274 18.2216 6.52328 17.915ZM3.86182 17.9146C3.88832 18.0716 3.96184 18.1377 4.08383 18.2347C3.98564 18.2011 3.88863 18.1748 3.78125 18.0841C3.87982 18.1126 3.80495 17.8899 3.86182 17.9146ZM6.02018 17.493C6.21102 17.5352 6.46157 17.5519 6.80231 17.5329C6.30669 17.6994 6.08443 17.6428 6.02018 17.493ZM6.64484 17.1949C6.64567 17.2202 6.60477 17.2692 6.56691 17.3005C6.80601 17.2962 7.03916 17.249 7.20856 17.0682C7.05116 17.1367 6.87277 17.1938 6.64484 17.1949ZM6.98265 16.6725C6.96528 16.703 6.90301 16.7676 6.85617 16.8144C7.05351 16.8355 7.44731 16.7479 7.6167 16.5672C7.4593 16.6357 7.21058 16.6714 6.98265 16.6725ZM7.44385 16.1704C7.4085 16.207 7.29208 16.315 7.24883 16.3498C7.44616 16.3708 7.89152 16.22 8.06092 16.0393C7.90352 16.1078 7.67178 16.1692 7.44385 16.1704ZM8.078 15.6123C8.06585 15.829 7.98955 15.967 7.90715 16.0589C7.97549 16.0375 8.04383 16.0234 8.11217 15.9935C8.1056 15.8737 8.09407 15.7321 8.078 15.6123Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3424",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4258 18.9562C14.6224 19.0023 14.8618 18.8792 14.9765 18.877C15.0299 18.9778 15.0506 19.0875 15.2704 19.1584C15.1254 19.3126 14.5802 19.3637 14.4258 18.9562Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3426",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6219 19.8095C16.5495 19.8777 16.4694 19.9505 16.332 20.029C16.5779 20.2427 17.0782 20.0028 17.0587 19.7957C17.014 19.7137 16.8698 19.8907 16.6219 19.8095Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3428",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5799 19.059C17.5842 19.3379 17.5466 19.4112 17.5137 19.5069C17.6538 19.5983 18.016 19.3812 18.054 19.053C18.016 18.9752 17.8622 19.111 17.5799 19.059Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3430",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2455 17.5186C18.1413 17.5436 18.2034 17.8822 18.084 17.9897C18.182 18.0417 18.2483 18.1663 18.32 18.2787C18.5498 18.1123 18.5413 17.6383 18.2455 17.5186Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3432",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6757 18.9246C14.7859 18.8928 14.9054 18.8391 14.9489 18.8533C15.0155 18.6286 14.8593 18.7592 14.6757 18.9246ZM14.5204 18.7445C14.7362 18.7424 15.0384 18.7776 15.1125 18.503C15.4466 18.6565 15.7968 18.3611 15.719 18.0892C15.719 18.0892 15.6112 18.5589 14.9199 18.2615C14.7818 18.2421 14.5906 18.3257 14.6032 18.4158C14.6125 18.531 14.8494 18.6289 14.5204 18.7445ZM16.3484 18.5148C16.5238 18.6848 16.6358 18.8423 16.5968 18.9701C16.7054 18.8202 16.7158 18.9106 16.7397 18.9682C16.8691 19.0636 16.9662 19.353 16.6424 19.5403C16.7944 19.5797 16.807 19.7094 16.6403 19.7561C16.6475 19.8931 17.0299 19.7224 17.0647 19.7778C17.0944 19.7654 17.1043 19.7245 17.1123 19.6809C17.1446 19.6389 17.1483 19.5902 17.1144 19.5324C17.3614 19.1395 17.0547 18.9247 16.7935 18.8811C16.6332 18.721 16.493 18.6251 16.3484 18.5148ZM16.3608 18.0912C16.6241 18.2504 16.9825 18.3748 17.3214 18.5861C17.6603 18.2632 17.9103 18.7964 17.4249 18.8316C17.5474 19.0475 18.0649 19.0333 18.0501 18.8613C18.3722 18.2775 17.4988 18.1345 17.3255 18.3446C17.0611 18.2019 16.8193 18.0418 16.4395 17.9744C17.1914 18.2834 17.3206 18.3802 17.1891 18.397C17.0694 18.4122 16.6484 18.184 16.3608 18.0912ZM16.5921 17.6422C16.7987 17.556 17.2469 17.5679 17.3674 17.4648C17.5651 17.1205 17.9319 17.2115 18.0486 17.4356C18.132 17.4348 18.1945 17.4521 18.2036 17.5158C18.1268 17.6789 18.176 18.078 17.9596 17.9801C17.9991 17.9509 17.9797 17.9217 17.9596 17.8926C17.8676 17.9811 17.8671 17.8802 17.8656 17.8391C17.7271 17.9944 17.657 17.9688 17.5555 17.946C17.5801 17.9364 17.591 17.9104 17.5885 17.8683C17.9933 17.7184 17.6421 17.2642 17.314 17.6884C17.2026 17.7202 16.7617 17.6255 16.5921 17.6422ZM13.3512 15.4619L13.3359 15.5081C13.5027 15.6526 14.9456 17.172 15.3745 17.8221C15.3103 17.6841 15.3373 17.627 15.0822 17.336C15.735 17.6859 16.056 17.3753 16.0176 17.3068C15.9645 17.3128 15.9301 17.3198 15.9014 17.3054C15.2982 17.5998 14.8507 17.1119 14.584 16.7891C14.9213 17.0464 15.1432 17.0925 15.494 17.1124C15.5288 17.0539 15.5335 17.0243 15.5423 16.9908C15.5117 16.9853 15.4823 16.9775 15.4584 16.9592C15.048 17.1074 14.5552 16.8097 14.1697 16.3102C14.5366 16.5622 14.7992 16.5378 15.0492 16.5411C15.0878 16.4987 15.1408 16.4618 15.1483 16.4074C15.1131 16.41 15.0856 16.3978 15.0568 16.388C14.799 16.4738 14.1676 16.4447 13.8646 15.9383C14.075 16.0734 14.3089 16.1531 14.6069 16.0817C14.6662 16.0382 14.7306 15.9954 14.7441 15.9456C14.3749 16.0351 14.0156 16.0338 13.6867 15.756C13.7803 15.7569 13.8787 15.7249 13.979 15.6807C13.7852 15.6962 13.5853 15.677 13.3512 15.4619Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3434",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.875 4.63887C9.59222 5.00607 10.4186 4.16711 10.9983 4.62292C11.0611 4.62639 11.0694 4.58165 11.0593 4.54332C10.3852 3.96466 9.66711 4.81675 8.875 4.63887Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3436",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61323 15.1699L8.55656 15.2271C8.48688 15.5282 8.32192 15.7687 8.13086 15.9988C8.30557 16.0259 8.52008 15.9315 8.72761 15.8456C8.59866 15.6153 8.57103 15.4619 8.61323 15.1699Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3438",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81468 14.7686C8.91433 14.9578 9.1043 14.648 9.19596 14.5645C9.07599 14.9739 8.83724 15.3879 9.35864 15.7725C9.09167 15.7984 9.01716 15.909 9.26459 16.1614C8.7815 15.934 8.50878 15.557 8.81468 14.7686Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3440",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21662 14.5454C9.05018 15.354 9.32457 15.6699 9.60045 15.7462C9.49484 14.8723 9.85983 14.2478 10.3656 13.77C10.3317 12.9556 10.2123 12.5901 10.119 12.0029C10.1257 12.2749 10.3272 13.0196 10.1904 13.5404C10.0482 14.0817 9.6428 14.6072 9.21662 14.5454Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3442",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53516 15.38C8.01486 15.4107 8.40509 15.2655 8.72222 14.9541C8.54828 15.3606 8.15305 15.551 7.56566 15.4944C7.77812 15.4578 7.78351 15.4231 7.53516 15.38Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3444",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.478 14.9144C7.43224 14.9829 7.39578 15.0158 7.35938 15.0485C8.11622 15.1426 8.53824 14.7969 8.82245 14.495C9.2418 14.5179 9.53112 14.2577 9.78225 13.9932C9.49962 14.2072 9.20995 14.3834 8.87996 14.3438C8.55582 14.7946 8.09923 15.0043 7.478 14.9144Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3446",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77222 14.3646C7.71574 14.4774 7.69777 14.4756 7.66797 14.5124C7.92445 14.5634 8.27586 14.4681 8.87581 13.9899C9.46884 13.9767 9.71709 13.6048 9.88594 13.4434C9.57073 13.7037 9.25094 13.8418 8.92614 13.8455C8.61155 14.1525 8.26701 14.4022 7.77222 14.3646Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3448",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.96917 13.9103L7.86133 14.0719C8.06775 14.0609 8.33953 14.069 8.91819 13.5597C9.3636 13.4698 9.7621 13.1511 10.1117 12.5938C9.82118 12.9363 9.55576 13.3035 8.96852 13.3535C8.81881 13.6816 8.42282 13.8184 7.96917 13.9103Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3450",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.848 14.584C12.8078 14.8779 12.7391 15.1445 12.6035 15.3471C12.618 15.4434 12.615 15.5396 12.6107 15.6359C12.8182 15.4337 12.971 14.8582 12.848 14.584Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3452",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1492 14.7256C13.3725 15.2801 13.1723 16.0178 12.459 16.1453C12.6795 16.2328 13.3407 15.9443 13.4332 15.0865L13.976 15.6709C14.0053 15.5365 14.0247 15.4009 13.9221 15.2034C13.4926 15.117 13.3553 14.9556 13.1492 14.7256Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3454",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.502 14.9043C13.7938 15.0261 14.3029 15.2056 14.814 14.9935C14.8907 15.0237 14.9674 15.0469 15.0441 15.0588C14.8704 15.2325 14.3819 15.2743 13.9333 15.2167C14.551 15.1395 13.614 15.0718 13.502 14.9043Z",
    fill: "#C5BDCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3456",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4844 13.9141C12.6963 14.0574 12.934 14.1441 13.2033 14.1409C13.4044 14.5062 13.9909 14.6078 14.3213 14.5913C14.3362 14.6411 14.3712 14.6846 14.4148 14.7253C14.1387 14.7264 13.7852 14.6406 13.2429 14.3128C13.0968 14.2645 12.5801 14.0348 12.4844 13.9141Z",
    fill: "#C3BDCA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3458",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.373 13.3672C12.5842 13.5342 12.8173 13.6229 13.0668 13.6525C13.323 13.9131 13.6242 14.0473 14.0195 14.0959L14.1021 14.2334C13.978 14.2454 13.3769 13.9881 13.1567 13.7934C12.7877 13.7058 12.5109 13.5307 12.373 13.3672Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3460",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4199 12.9277C12.6641 13.1567 12.9427 13.2499 13.1676 13.2509C13.3364 13.4201 13.4925 13.5947 13.847 13.684C13.8642 13.7302 13.885 13.7695 13.9117 13.7975C13.6447 13.793 13.278 13.4388 13.2323 13.3815C12.8741 13.3324 12.4672 13.1596 12.4199 12.9277Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3462",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2891 11.8902C10.3664 11.8619 10.4021 11.8202 10.4404 11.7793C10.5049 11.8639 10.597 11.8825 10.6876 11.9047C10.5153 11.8989 10.4935 11.9765 10.5766 12.1121C10.6119 12.1663 10.6724 12.9778 10.6876 13.4676C10.6895 13.9213 10.7531 14.216 10.849 14.413C10.474 14.111 10.682 12.2839 10.2891 11.8902Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3464",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9141 11.9246C11.1237 11.9058 11.3311 11.8945 11.5799 11.751L11.6707 11.8523C11.4922 12.2247 11.3917 13.104 11.2773 13.8927C11.3101 13.3907 11.3208 12.9426 11.2924 12.817C11.2349 12.5336 11.2465 12.3612 11.252 12.3153C11.3653 11.9217 11.0546 12.0179 10.9141 11.9246Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3466",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7516 11.8955L11.7768 11.9196C11.4232 12.657 11.7785 14.3475 11.0151 15.1997L11 14.8717C11.5784 14.5068 11.4336 12.6433 11.7516 11.8955Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3468",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4761 13.7139C10.4721 14.9214 10.6801 15.1498 9.82031 16.1547C10.2208 15.8354 10.6688 14.8581 10.6123 15.4167C10.7137 15.2374 10.8119 15.0593 10.8342 14.9054C10.5026 14.3632 10.5172 14.0493 10.4761 13.7139Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3470",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1719 15.0449L11.0098 15.2282L11.0554 16.8249C11.076 16.1623 11.1108 15.5534 11.1719 15.0449Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3472",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5553 13.8877C11.5114 14.1345 11.4822 14.431 11.4141 14.5968C11.5307 15.8743 11.8941 15.997 12.1959 16.1114C11.6923 15.4285 11.5928 14.5119 11.5553 13.8877Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3474",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5871 15.5615C10.431 15.8991 10.4825 16.5473 10.0423 16.97C10.4074 16.7911 10.5461 16.3573 10.5568 16.0198L10.5921 16.3767C10.4709 17.1084 10.1235 17.3076 9.88086 17.3511C9.91935 17.3409 10.3002 17.4178 10.6501 16.6758C10.6616 16.9454 10.4636 17.2455 10.2062 17.3463C10.4313 17.3535 10.6544 17.1558 10.7687 17.0038C10.5839 16.4821 10.5805 16.0201 10.5871 15.5615Z",
    fill: "#E0DEE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3476",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7559 16.6588C10.7936 16.8341 10.8472 17.0895 11.0535 17.3366L11.0686 17.6453C11.1632 17.5266 11.5285 16.5373 11.5352 16.2127C11.5488 16.1098 11.5548 15.9903 11.6336 16.0679C11.6437 16.0751 11.6538 16.0753 11.6638 16.0631C11.5532 15.9908 11.4365 15.6336 11.3486 15.5156C11.4142 15.902 11.4655 16.449 11.0535 17.2642C10.9292 17.1224 10.8404 16.8957 10.7559 16.6588Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3478",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5172 17.2864C12.0733 17.5045 11.6912 16.9786 11.5078 16.652L11.5902 16.2061C11.592 16.1914 11.6248 16.1804 11.6395 16.2002C11.7126 16.6911 12.0374 17.264 12.5172 17.2864Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3480",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4288 16.8223L11.3809 16.9573C11.5521 17.3205 11.7538 17.4467 12.0165 17.5386C11.5006 17.2956 11.4656 17.059 11.4288 16.8223Z",
    fill: "#DFDDE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3482",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9355 17.4453L11.0724 17.6696L11.1763 17.4501C11.1568 18.042 11.1164 18.7569 11.0977 19.4157C11.0406 18.7549 10.9625 18.066 10.9355 17.4453Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3484",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3339 17.0762C11.3213 17.11 11.3087 17.1419 11.2961 17.163C11.7539 18.7867 11.2151 19.6526 11.0943 19.7798C10.7771 19.2415 10.7807 18.7113 10.7109 18.258C10.7518 18.6645 10.7053 19.1931 11.0741 19.8522L11.0792 20.1199C11.5287 19.5841 11.8018 18.8405 11.4525 17.2281C11.402 17.1879 11.3724 17.1278 11.3339 17.0762Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3486",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9277 19.9727C10.9661 20.0315 10.9994 20.0912 11.0765 20.1439C11.1759 20.0446 11.1974 19.9951 11.2405 19.9316C11.1567 20.3625 11.1186 20.7824 11.0589 21.2075C11.0177 20.7872 10.9872 20.3291 10.9277 19.9727Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3488",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7324 20.0425C11.6353 19.8352 11.5205 19.6569 11.5936 19.4275C11.5796 19.3568 11.5489 19.346 11.5154 19.3311C11.495 19.4535 11.4496 19.5404 11.4095 19.6253C11.5814 20.6119 11.3373 21.1428 11.0539 21.5885C10.5893 20.9904 10.6756 20.3457 10.668 19.7941C10.5326 20.9139 10.8155 21.4064 11.0488 21.6609L11.0514 21.9334C11.7131 21.0036 11.6479 20.1401 11.5003 19.729C11.5735 19.8362 11.6403 19.9474 11.7324 20.0425Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3490",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22461 17.2109C9.31334 18.0244 10.3933 17.7779 10.8312 17.1627L10.7909 17.0518C10.3825 17.5578 9.51186 18.0077 9.22461 17.2109Z",
    fill: "#C4BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3492",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7302 17.5098C10.334 18.2959 9.85682 18.8556 9.19922 18.911C9.64726 18.9452 10.127 18.5972 10.2762 18.4455C10.3839 18.2667 10.5235 18.2031 10.3872 18.4431C10.3343 18.5274 10.2817 18.5889 10.198 18.665C10.3039 18.624 10.5234 18.3001 10.5688 18.2719C10.5874 17.9315 10.668 17.7431 10.7302 17.5098Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3494",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5678 18.2998C10.5601 18.3895 10.5519 18.4802 10.5535 18.5522C9.92908 19.1656 9.38962 19.3598 8.81641 19.231C9.28969 19.2432 9.83821 19.2913 10.5678 18.2998Z",
    fill: "#C3BECA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3496",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54385 18.6542C8.40633 18.3281 8.45785 18.0651 8.7008 17.8663C8.21077 17.8564 7.67944 18.728 8.58666 19.1693C8.13267 18.9156 8.10973 18.3865 8.25784 18.2127C8.35678 18.0617 8.50231 18.0195 8.40118 18.1886C8.331 18.4608 8.45862 18.5997 8.54385 18.6542Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3498",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4805 17.2764C11.5732 17.4185 11.6874 17.5401 11.8372 17.6277C11.7964 18.4233 12.7116 18.9508 13.3317 18.726C12.9755 18.9752 11.8016 18.9145 11.4805 17.2764Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3500",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6152 18.2764V18.3719C12.0449 19.0559 12.7676 19.0808 12.9885 19.054C12.3138 19.0418 11.8911 18.7426 11.6152 18.2764Z",
    fill: "#C4C0CD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3502",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4888 17.7783C14.0586 18.1562 13.9013 18.744 13.2891 18.9892C13.7601 18.6927 13.9915 18.3088 13.4888 17.7783Z",
    fill: "#E1DFE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3504",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8223 19.1562C13.3636 19.2506 14.2795 18.8444 13.7889 17.9385C14.2852 18.4896 13.7301 19.4794 12.8223 19.1562Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3506",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6191 18.8213C11.6143 18.8726 11.6115 18.9043 11.5977 18.9884C12.0611 19.8729 12.3199 19.9311 12.6214 20.1618C12.0598 19.7605 11.7728 19.3042 11.6191 18.8213Z",
    fill: "#E0DEE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3508",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3789 20.4824C12.477 20.524 12.5528 20.4935 12.6322 20.5199C13.3407 20.7559 14.2178 20.3535 13.9555 19.5342C14.4192 19.9662 13.5661 21.2074 12.3789 20.4824Z",
    fill: "#C4BECB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3510",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6238 19.2959C14.1606 19.8048 13.6092 20.5088 12.8926 20.268C13.652 20.366 13.9329 19.764 13.6238 19.2959Z",
    fill: "#C3BECA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3512",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41335 19.292C7.6792 19.7542 8.08467 20.3265 8.42405 20.4585C8.29495 20.3675 8.15727 20.0484 8.55959 20.2266C8.692 20.2809 8.8099 20.2866 8.92342 20.2777C8.17217 20.0418 8.33905 19.6595 8.41335 19.292Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3514",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5595 18.6475C10.5772 18.8879 10.6048 19.0812 10.6415 19.2307C10.4057 19.6813 10.1211 19.9817 9.82828 20.196C10.1718 19.8782 10.4369 19.5598 10.5524 19.2239C9.95431 20.1164 9.53979 20.2535 9.11133 20.2744C9.64427 20.1622 10.4226 19.7221 10.5595 18.6475Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3516",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.649 19.2646C10.6654 19.3368 10.6832 19.4081 10.7275 19.4624C9.97407 20.8518 8.96741 20.8118 8.62305 20.6972C9.27536 20.7617 9.04837 20.6491 8.83706 20.6119C9.61014 20.6356 10.2929 20.1339 10.649 19.2646Z",
    fill: "#C3BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3518",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0293 11.6167C10.1266 11.554 10.1728 11.479 10.2293 11.4033C10.2501 11.4412 10.2892 11.4742 10.3385 11.5076C10.1959 11.5522 10.146 11.7528 10.0658 11.7538C10.053 11.7093 10.0526 11.6613 10.0293 11.6167Z",
    fill: "#C4BECA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3520",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3457 11.5109C10.5591 11.5877 10.7771 11.5778 11.0466 11.3965C11.0705 11.4202 11.1045 11.4487 11.1376 11.4768C10.8802 11.6524 10.4588 11.6072 10.3457 11.5109Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3522",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2578 11.5087C11.4093 11.533 11.5578 11.5657 11.7554 11.4629C11.7839 11.499 11.8125 11.5274 11.841 11.5545C11.7765 11.616 11.4525 11.6071 11.2578 11.5087Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3524",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8831 11.1217C11.9319 11.1503 12.0194 11.2342 12.1043 11.2822C12.0413 11.367 11.9783 11.4633 11.9152 11.5708C11.6341 11.3373 11.8314 11.0913 11.8831 11.1217Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3526",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83203 11.189C9.87224 11.2428 9.90045 11.2813 9.92655 11.317C10.0984 11.2028 10.1563 11.0799 10.2119 10.9567C10.1867 10.9429 10.1628 10.9232 10.1424 10.8867C10.0069 11.1164 9.92154 11.1442 9.83203 11.189Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3528",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2247 10.9628L10.2051 10.9985C10.5444 11.1844 11.0954 11.3238 11.7959 10.9849L11.7264 10.8486C11.2725 11.1879 10.7594 11.2451 10.2247 10.9628Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3530",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8535 10.9612C12.0534 10.9251 11.984 10.6872 12.1692 10.615C12.4725 11.0512 12.9908 10.9379 13.2018 10.6064L13.2357 10.8521C13.0357 10.9736 12.7702 11.1847 12.3279 10.9885C12.2931 11.0591 12.2852 11.1702 12.2833 11.2903C12.0895 11.229 11.9335 11.1314 11.8535 10.9612Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3532",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4656 10.1514C12.5426 10.2936 12.4706 10.6175 12.4746 10.7234C12.327 10.704 12.2452 10.5887 12.166 10.4929C12.1816 10.4901 12.192 10.4859 12.1981 10.4741C12.2164 10.3852 12.3888 10.3442 12.4656 10.1514Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3534",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1352 10.5504L11.1191 10.5708C11.3517 10.6517 11.8338 10.6923 12.1767 10.4702L12.1161 10.3662C11.8765 10.5621 11.5693 10.654 11.1352 10.5504Z",
    fill: "#C3BECA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3536",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 10.4756C11.0427 10.5075 11.0837 10.5335 11.1215 10.5473C10.8023 10.8265 10.3414 10.7504 9.87662 10.5166C9.88137 10.5029 9.87765 10.4892 9.87305 10.4756C10.4099 10.7537 10.7849 10.675 11.0002 10.4756Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3538",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8497 10.4736C9.96264 10.6447 9.67598 10.7003 9.67493 10.9552L9.56257 10.8186C9.55787 10.6516 9.79106 10.6784 9.8497 10.4736Z",
    fill: "#C3BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3540",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53847 10.7668L9.31911 10.4479C9.08813 10.1602 9.8517 10.103 9.76854 9.56445C9.81728 9.6013 9.86603 9.64895 9.91478 9.67362C9.88688 10.1073 9.48978 10.0959 9.48318 10.3933C9.43249 10.3749 9.40675 10.3297 9.39401 10.2705C9.37438 10.2847 9.36995 10.2861 9.34942 10.3063C9.25319 10.4195 9.39496 10.4836 9.53847 10.7668Z",
    fill: "#C3BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3542",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74609 10.1827C9.96912 10.2132 10.1884 10.1826 10.3981 9.99219C10.4341 10.0255 10.4623 10.0607 10.5103 10.0911C10.243 10.2467 9.88489 10.2679 9.74609 10.1827Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3545",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5213 10.0982L10.4961 10.1175C10.8662 10.3205 11.3829 10.319 11.6613 10.1369C11.6219 10.115 11.5882 10.0877 11.5554 10.0596C11.2241 10.2927 10.7254 10.2175 10.5213 10.0982Z",
    fill: "#C4BECA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3547",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6693 10.1369L11.6504 10.1598C11.9134 10.2576 12.2382 10.2479 12.4663 10.1321C12.4507 10.0906 12.4334 10.0504 12.4045 10.0186C12.1574 10.205 11.9131 10.1891 11.6693 10.1369Z",
    fill: "#C4BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3549",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95312 9.69968C10.3393 9.88745 10.7605 9.76256 10.9911 9.56836C11.0303 9.61601 11.0696 9.6437 11.1088 9.66899C10.8209 9.91051 10.0802 9.88027 9.95312 9.69968Z",
    fill: "#C4BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3551",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1231 9.67382L11.1035 9.69086C11.4514 9.91819 11.9827 9.78093 12.1236 9.69256C12.1058 9.63913 12.088 9.59251 12.0701 9.55273C11.8258 9.75263 11.462 9.81814 11.1231 9.67382Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3553",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97656 9.2035L9.0265 9.23077C9.07955 9.15812 9.12324 9.14063 9.14514 9.16943C9.16703 9.19822 9.12678 9.25161 9.18344 9.29902C9.36329 9.16225 9.77563 9.07164 9.82549 8.86923C9.90127 9.07193 10.1582 9.07775 10.3677 9.42861C10.3181 9.16216 10.0323 9.0893 9.9152 8.91016C9.79805 8.73102 9.8674 8.50695 9.96103 8.21777C9.7667 8.46953 9.91977 8.82703 9.60271 8.98702C9.40145 9.08856 9.01755 9.0662 8.97656 9.2035Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3555",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.642 7.9375L10.6527 8.17626C10.323 8.29958 10.58 9.08855 10.4494 9.26088C10.3973 8.58768 10.1074 8.34538 10.642 7.9375Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3557",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9093 8.51074H10.9485C10.9913 8.95187 11.4752 8.99387 11.5584 9.42823C11.4556 9.12714 11.1808 9.03934 11.0341 8.87909C10.9497 9.21613 10.5241 9.3163 10.417 9.50671C10.3877 9.34988 11.0041 9.13031 10.9093 8.51074Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3559",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6416 8.08767C11.388 8.47136 11.8927 8.71829 11.6202 9.35651C11.762 8.52182 11.1525 8.58994 11.5381 7.98535C11.6719 8.10958 12.13 8.23558 12.173 8.44583C12.019 8.23806 11.7818 8.22225 11.6416 8.08767Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3561",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1678 8.5C12.2156 8.64754 12.258 8.70621 12.2962 8.80354C12.1573 9.23736 11.6089 9.38845 11.5793 9.54713C11.4845 9.34438 12.1712 9.23138 12.1678 8.5Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3563",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.689 8.05743C12.6027 8.03993 12.5201 8.05504 12.425 7.96191C12.4412 8.10227 12.417 8.18471 12.3965 8.27234C12.5762 8.37127 12.6948 9.29202 12.7674 9.33308C12.7304 8.93708 12.7471 8.41583 12.4964 8.13247L12.5071 8.08474C12.583 8.11094 12.6415 8.10384 12.689 8.05743Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3565",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32617 8.77657C9.49808 8.53018 9.64724 8.24332 9.86789 8.09582C10.0885 7.94833 10.2273 8.00501 10.6709 7.65783L10.8385 7.23828C10.4642 7.76411 10.0224 8.12421 9.38324 7.99891C9.42132 8.01945 9.44248 8.06983 9.70426 8.08419C9.56875 8.20973 9.45232 8.4808 9.32617 8.77657Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3567",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23242 7.61372C9.56765 7.77433 9.97734 7.85644 10.6806 6.89744C10.83 6.85829 10.9758 6.78069 11.1157 6.6416C10.6635 7.68072 9.37748 8.31589 9.23242 7.61372Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3569",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7305 8.21404C11.2669 6.27967 12.8943 5.12408 11.4867 4.09375C12.5075 5.78507 10.8832 6.5004 10.7305 8.21404Z",
    fill: "#F1EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3571",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3418 6.53936C10.3695 7.04812 11.0414 6.67084 11.2014 6.33789C10.9294 6.51366 10.66 6.67229 10.3418 6.53936Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3573",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3524 5.75151C11.4141 5.66433 11.4256 5.74486 11.5307 5.76855C11.2849 6.25852 10.869 6.39236 10.6426 6.40297C10.9494 6.2506 11.2314 6.0753 11.3524 5.75151Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3575",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1875 4.932L11.2405 4.98262C11.3145 4.97969 11.3884 4.98044 11.4624 4.91513C11.4635 4.97672 11.4392 5.00432 11.4069 5.02124C11.4485 5.37758 11.4074 5.5854 11.3557 5.74436C11.4203 5.68169 11.473 5.77164 11.5313 5.76747C11.6241 5.62764 11.7829 5.14151 11.528 4.71973C11.5351 4.8409 11.3984 4.96562 11.1875 4.932Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3577",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3125 4.77792C10.7195 4.61949 10.952 4.89823 11.1347 4.92459C11.425 5.33313 11.1242 5.68881 10.9296 5.90694C11.0589 5.69525 11.2483 4.84526 10.3125 4.77792Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3579",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6777 8.43864C11.1209 8.63725 11.3272 8.15511 11.5374 7.96797C11.4326 7.73862 11.4628 7.55036 11.4553 7.35059C11.0703 7.55077 11.0811 8.27707 10.6777 8.43864Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3581",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.192 5.02832C12.1557 5.04429 12.1525 5.18081 12.1029 5.17837C12.072 6.15363 11.1439 6.69575 10.9258 8.10491C11.0612 7.95391 11.1586 7.35939 11.507 6.81301C11.8707 6.2427 12.2279 5.92262 12.192 5.02832Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3583",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7162 6.87109C11.3463 7.82398 12.0791 7.8317 12.1424 8.14212C11.383 7.89816 11.3297 7.36883 11.7162 6.87109Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3585",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8534 4.13867C13.082 4.90256 12.028 6.44436 11.5684 6.85921C11.7502 6.46973 12.8578 5.39769 11.8534 4.13867Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3587",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.266 3.7168C12.3919 3.93757 12.5944 4.28537 12.2962 4.21606C12.8188 5.32531 12.2456 5.89545 11.9579 6.51226C11.3515 8.0232 12.3553 7.42401 12.2382 8.47778C12.5796 8.09668 12.1353 7.54366 12.1545 7.35313C12.1299 7.07633 12.3125 6.47834 12.3719 6.11659C12.4447 6.31608 12.5565 6.437 12.6897 6.51453C12.4551 5.72906 13.1879 4.18086 12.266 3.7168Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3589",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3885 6.31641C12.4474 6.39459 12.4892 6.48379 12.5852 6.53833C12.6345 6.84575 12.1832 7.82038 12.8626 7.89377C12.3098 8.15745 12.0086 7.40083 12.3885 6.31641Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3591",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0898 3.41158C12.2054 3.41945 12.4815 3.60455 12.739 3.4082C12.9159 3.63792 12.5864 3.83238 12.2399 3.66047C12.1494 3.60508 12.4363 3.57941 12.0898 3.41158Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3593",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0391 3.49512C10.143 3.60554 10.2491 3.66271 10.3468 3.92978C10.4191 3.93052 10.4914 3.93874 10.5637 3.95878C10.4418 3.77375 10.2942 3.60352 10.0391 3.49512Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3595",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1562 3.17475C12.2254 3.44756 12.1248 2.97258 12.3165 2.9043C12.5062 3.19487 11.985 3.57186 11.1562 3.17475Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3597",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85055 3.37724C9.79003 3.35736 9.73424 3.361 9.69922 3.36517C9.79434 2.63172 10.6436 3.09749 11.1016 3.37244C10.5235 3.10732 9.79896 2.77031 9.85055 3.37724Z",
    fill: "#C3BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3599",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.85288 3.37737C9.80533 2.54349 11.0604 3.49601 11.6411 3.52951C11.237 3.57338 9.90579 2.72509 9.91341 3.39186L9.85288 3.37737Z",
    fill: "#F1EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3601",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93359 3.40079L10.0395 3.43937C10.0499 3.36655 10.079 3.28276 10.1177 3.27537C10.3641 3.22859 10.1331 3.35244 10.1732 3.39114C10.2197 3.4225 10.2714 3.45385 10.3245 3.48521C10.3271 3.44981 10.3296 3.40806 10.3321 3.35978C10.3363 3.17008 10.9058 3.47555 11.3057 3.60098C11.3498 3.71406 11.0838 3.85603 10.8744 3.81564C11.0647 3.95955 11.466 3.88966 11.6386 3.65403C11.946 3.67636 12.0138 3.62825 12.0825 3.55514C11.8475 3.50856 11.739 3.61909 11.1502 3.46355C10.6093 3.31519 9.94868 2.87422 9.93359 3.40079Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3603",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4232 3.3067C10.4895 3.30063 10.5501 3.32207 10.6098 3.34777C10.4899 3.52548 10.6656 3.69501 10.7637 3.66895C10.7969 3.6979 10.8307 3.7269 10.9428 3.75586C10.7845 3.7875 10.2551 3.63131 10.4232 3.3067Z",
    fill: "#B6B1BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3665",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.02259 4.33178C8.4293 3.24039 10.1457 3.04768 10.3196 3.95068C10.3196 3.95068 10.7452 3.9671 11.121 4.15813C11.8534 4.66626 11.4085 4.957 11.261 4.93365C10.9197 4.93934 10.8556 4.62595 10.3575 4.74563C10.2377 4.78838 10.2313 4.84721 10.1777 4.84548C9.88078 4.77332 10.4253 4.20306 11.0101 4.61394C11.0622 4.65058 11.1761 4.57899 11.0756 4.47164C10.6835 4.09318 10.004 4.30116 9.8549 4.33661C9.66506 4.04223 9.24518 4.10961 9.02259 4.33178Z",
    fill: "#F6D155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3605",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.726 3.44141C10.8006 3.49827 11.1788 3.55691 11.1875 3.59074C11.0664 3.86365 10.6707 3.77942 10.726 3.44141Z",
    fill: "#AAA3B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3607",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2603 10.8366C13.2576 10.8416 13.2518 10.8445 13.2603 10.8571C13.3503 10.8996 13.4616 10.9252 13.592 10.9355L13.9023 12.6853C13.8787 12.23 13.8455 11.7595 13.8345 11.3244C13.7998 11.2408 13.7744 11.0868 13.7489 10.9321C13.7882 10.9281 13.8274 10.9221 13.8667 10.9116C14.0632 12.0176 14.5439 12.2402 14.6371 12.3271C14.3828 12.0714 14.0394 11.7117 13.9273 10.8878C14.0976 10.7969 14.1753 10.6867 14.2305 10.6695C14.2476 10.6228 14.2367 10.5112 14.2126 10.458C14.0415 10.6144 13.887 10.7985 13.5421 10.7718C13.5189 10.77 13.5421 10.8025 13.5421 10.8025C13.6755 10.9733 13.4057 10.8686 13.2603 10.8366Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3609",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9238 12.8727L13.9381 13.1388C14.1102 13.0326 14.2717 12.9999 14.5017 12.4941C14.5956 13.3907 14.6076 14.2624 15.1544 14.4417C14.8719 13.8256 14.8713 13.1491 14.8512 12.4975C14.8179 12.5386 14.7846 12.5681 14.7514 12.5964C14.5264 12.472 14.4574 12.3724 14.3376 12.2588C14.2623 12.4822 14.2246 12.717 13.9238 12.8727Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3611",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3301 10.7061C14.4056 10.7328 14.4908 10.7411 14.5798 10.7422L14.6756 12.0446L14.3301 10.7061Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3613",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9789 10.6124L15.0243 10.5811C15.1352 10.8202 15.2851 11.0315 15.5035 11.1936L16.0911 14.9754L15.2412 11.184C15.237 11.837 15.0482 12.2703 14.7418 12.5636L14.709 12.3152C15.0309 11.8963 15.2245 11.3952 14.9789 10.6124Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3615",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.875 11.4805C15.9641 11.5319 16.0667 11.5737 16.1827 11.6058C16.5395 12.7467 16.6742 14.9955 16.2054 15.8097L16.1651 15.501C15.3447 14.9014 15.1402 13.2306 14.9746 12.2956L14.9998 12.2498C15.1581 13.104 15.3447 14.7485 16.1474 15.4166C16.292 14.9792 16.6044 13.718 16.044 11.6155C16.0027 11.5705 15.9351 11.5255 15.875 11.4805Z",
    fill: "#C4BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3617",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.373 10.2653C15.4437 10.257 15.4826 10.2617 15.595 10.2363L16.3769 11.353L15.373 10.2653Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3619",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2129 11.6152C16.3262 11.6523 16.4701 11.6834 16.6164 11.7141C16.6208 11.7482 17.7603 14.5502 18.556 14.7651C17.5388 14.9583 17.0278 13.2521 16.3642 12.2447C16.317 12.0318 16.2668 11.8217 16.2129 11.6152Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3621",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0806 9.92969C16.0709 9.94429 16.0612 9.9589 16.0449 9.96719C16.5085 10.6538 16.5198 11.0722 16.4587 11.4475L16.6477 11.6829C16.7419 11.1577 16.6402 10.7703 16.5086 10.4038L18.8164 13.61L16.7761 10.4891L17.2077 10.5471C16.848 10.4316 16.4839 10.3921 16.0806 9.92969Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3623",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4733 10.5539C17.5614 10.5546 17.6406 10.5496 17.7003 10.5322C18.1575 11.2447 19.3362 12.539 19.1985 14.2995L19.0547 14.0318C17.9611 13.7902 17.2004 12.4763 16.8125 11.9431C17.4528 12.7504 18.1783 13.8034 19.027 13.9691C19.0972 12.6548 18.0604 11.3655 17.4733 10.5539Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3625",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7109 10.5298L17.7502 10.5946C18.762 11.1096 19.8971 12.1298 20.6001 11.3791C19.8715 11.6591 18.6914 10.676 17.9143 10.3047L17.9499 10.465C17.8639 10.5047 17.7877 10.5166 17.7109 10.5298Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3627",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2786 9.32604C16.2813 9.35364 16.2783 9.37575 16.2715 9.39428L17.5306 10.1413L16.3821 9.26465C16.3544 9.29275 16.3157 9.30694 16.2786 9.32604Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3629",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8457 10.0283C17.8677 10.1086 17.8931 10.1856 17.9062 10.2743C19.4123 10.9405 20.315 10.7764 20.7513 10.5155L20.5192 10.4335C19.8563 10.853 18.252 10.2864 17.8457 10.0283Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3631",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6499 8.89007C16.6498 8.90938 16.642 8.92865 16.6348 8.94796C17.2741 9.27047 17.7217 9.86937 17.7042 10.2817L17.9211 10.453C17.8376 9.76358 17.579 9.50572 17.3183 9.24943L20.3777 10.3951L17.4066 9.06373C17.8028 8.97766 18.2159 8.95612 18.5567 8.56207L19.2578 8.53793C19.8559 8.45018 20.5357 8.11917 20.6047 7.80957L20.3802 7.83367C20.0931 8.44049 18.9618 8.41965 18.3751 8.44148C18.1032 8.92906 17.2383 8.96533 16.6499 8.89007Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3633",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3607 8.75714C18.2844 8.81573 18.2041 8.8593 18.1211 8.89218C18.4409 8.95691 18.7387 9.03971 19.0114 9.14303C19.8027 9.22232 20.5864 9.10688 20.6206 8.46289C20.2881 8.97564 19.3393 8.88112 18.3607 8.75714Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3635",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6367 8.30664C16.6583 8.36901 16.6667 8.42396 16.6796 8.48415L18.3014 8.44337C17.7464 8.39786 17.1791 8.35818 16.6367 8.30664Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3637",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4199 7.68164C17.7497 7.82552 18.0502 7.98687 18.2926 8.16942L18.0782 7.98105C18.7719 7.92636 19.4774 7.87336 20.2574 7.83134L17.7907 7.81684L17.4199 7.68164Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3639",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8986 7.73623C16.8912 7.76919 16.8727 7.80215 16.8594 7.83516L17.4015 7.68506C18.2129 7.12883 18.2513 6.85054 18.3539 6.54924L19.5916 5.8125L18.1863 6.48104C17.423 6.4881 17.2279 6.58926 16.9949 6.64817C17.6418 6.51413 18.0673 6.49115 18.304 6.5629L18.1542 6.65156C17.959 7.26762 17.231 7.62644 16.8986 7.73623Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3641",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8926 7.23103C16.9158 7.27019 16.9193 7.31875 16.9304 7.36368C17.3176 7.16556 17.6793 6.94302 18.0402 6.71973C17.6576 6.89924 17.2751 7.0825 16.8926 7.23103Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3643",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9355 7.30841C18.3712 7.27318 18.814 7.26332 19.2698 7.29876C19.3762 7.24145 20.4801 6.9333 20.2131 6.375C19.8956 6.98644 18.7169 7.19574 18.6241 7.2457C18.4387 7.26373 17.9808 7.28151 17.9355 7.30841Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3645",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7569 5.73508L20.0016 5.63379C20.0277 5.68115 19.8507 5.99917 19.5372 6.33179C19.1279 6.76566 18.8872 6.95362 18.1074 7.08813C18.1226 7.06824 18.1365 7.04831 18.1484 7.02843C18.7513 6.87152 19.5809 6.30918 19.7569 5.73508Z",
    fill: "#DFDCE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3647",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1644 6.34766L17.0938 6.45381C17.789 5.97469 18.3389 5.68197 18.7584 5.55658C19.1748 5.1358 19.2698 4.72012 19.0964 4.47852C19.123 5.25631 17.8316 5.83809 17.1644 6.34766Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3649",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7184 6.64493L16.6931 6.84268C17.207 6.48402 17.4837 5.83264 17.412 5.28223L17.2278 5.4631L16.4258 6.08539C16.4689 6.12236 16.5163 6.15932 16.5468 6.19633L17.2278 5.48241C17.2729 6.07054 16.8586 6.52718 16.7184 6.64493Z",
    fill: "#C3BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3651",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4171 5.72307L17.3691 5.88708C17.7009 5.68723 17.9335 5.47743 18.1384 5.26483C18.7123 4.62677 18.787 4.07227 18.8345 3.80566L18.5874 3.99619C18.6273 4.80682 17.6769 5.58796 17.4171 5.72307Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3653",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1348 5.26707C17.2306 5.26324 17.3265 5.26068 17.4223 5.2695L18.5497 4.03223L17.1348 5.26707Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3655",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3043 4.56543L16.1656 4.71978C16.2249 5.0238 16.2227 5.43312 15.752 5.93053L15.7671 5.95706L15.7999 5.9474C16.1727 5.50327 16.565 5.38799 16.9576 5.27693C16.729 5.33134 16.501 5.36707 16.2438 5.49398C16.4193 4.98474 16.3411 4.7239 16.3043 4.56543Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3657",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.358 4.97106L16.3555 5.06996C16.7588 4.83281 17.1673 4.54462 17.5358 4.15102C17.7511 3.8859 18.0276 3.51413 18.0605 3.00781L17.8486 3.16703C17.8067 4.00881 16.6722 4.73383 16.358 4.97106Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3659",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4414 4.86216C15.7685 4.72691 16.0877 4.59872 16.309 4.55829L17.729 3.29688C17.3494 3.55969 16.5512 4.22031 16.1756 4.48836C16.0463 4.58065 15.9164 4.57768 15.4414 4.86216Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3661",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8053 3.17676C14.2152 3.7759 12.2209 7.91769 14.6224 7.54455L14.4887 7.51324C14.0082 7.55371 13.8853 7.15343 13.932 6.89998C13.9746 6.62339 14.2504 6.4714 14.3298 6.44536C14.3084 6.2012 14.3001 5.95901 14.5492 5.75499C14.6492 5.52391 14.7632 5.40493 14.8771 5.2847C15.2544 3.97807 17.1587 3.32727 17.8053 3.17676Z",
    fill: "#F1EEF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3663",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1324 4.70996C15.6837 4.77243 15.0685 5.24722 14.9754 5.44551C14.966 5.46547 14.9805 5.49382 14.8209 5.5758L14.8285 5.60233C14.9825 5.53974 15.3995 5.59973 15.0075 5.69396C15.2646 5.68736 15.4883 5.78452 15.6381 6.11124C16.4679 5.99036 16.6735 6.57036 16.4654 6.95537C17.0123 7.40884 16.6664 7.99288 16.367 8.10098C16.5494 8.48897 16.6458 9.00452 16.087 9.20318C16.0855 9.54929 16.0355 10.0882 15.1791 10.0811C15.0766 10.3142 14.7724 10.7126 14.2559 10.5008C14.2559 10.5008 14.2553 10.5151 14.2509 10.5297C14.2425 10.557 14.4644 10.6102 14.4678 10.5972C14.6438 10.6166 14.6643 10.7266 14.4501 10.6793C14.3725 10.6572 14.3037 10.6393 14.2484 10.6141C14.2496 10.6318 14.2503 10.6495 14.2383 10.6672C14.796 10.8514 15.1175 10.5292 15.2926 10.2523C15.9575 10.219 16.2326 9.86855 16.2661 9.32138C16.8107 8.99508 16.734 8.50316 16.5663 8.16369C17.0515 7.81672 17.0167 7.2075 16.6495 6.92402C16.8989 6.12374 16.1526 5.908 15.7592 5.96412C15.6268 5.75081 15.5402 5.71987 15.4464 5.66021L16.1501 4.74611L15.2951 5.58784C15.2099 5.55991 15.0986 5.54749 14.9596 5.55166C15.1408 5.1161 15.8521 4.78612 16.1324 4.70996Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3667",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59375 3.75512C9.70044 3.90759 9.87939 3.71249 10.1789 4.01351L10.2142 3.99905C10.1469 3.74004 9.96408 3.5824 9.69464 3.55469C9.80946 3.65127 9.72585 3.65697 9.72136 3.71869C9.71741 3.77293 9.72305 3.83935 9.59375 3.75512Z",
    fill: "#DFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3669",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11823 4.22331C9.28075 4.13885 9.63496 4.01206 9.85975 4.31498C10.5681 4.11686 11.069 4.29852 11.1385 4.57061C11.1824 4.49656 10.9825 4.08678 10.175 4.15576C9.48527 3.6945 9.09429 4.11158 9.11823 4.22331Z",
    fill: "#DFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3671",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1987 4.80405C10.0757 4.7991 10.4588 4.36627 11.0865 4.77992C11.3115 4.86404 11.4188 4.75438 11.3765 4.5773C11.3616 4.44689 11.2862 4.37432 11.2403 4.27344C11.556 4.50015 11.5944 4.77971 11.3806 4.89235C11.0481 5.05078 10.8145 4.48682 10.1987 4.80405Z",
    fill: "#DEA12F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3673",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67818 10.9787L9.81669 11.1705L9.77848 11.1476C9.384 11.3279 9.18038 11.2573 8.98564 11.175L8.96653 11.1613C8.56128 11.238 8.30332 11.1363 8.08772 10.9832C8.10299 11.0985 8.18754 11.1874 8.29787 11.2664L7.87279 13.0476L8.07817 11.376C7.8344 12.0289 7.51524 12.3341 7.07517 12.5178L7.10861 12.3351C7.5107 12.1385 7.85445 11.766 8.01608 10.9604C7.85581 10.9807 7.6954 10.9996 7.52891 10.9604L7.12771 12.2803L7.31876 10.9147C7.14444 10.8043 6.99844 10.6669 6.85547 10.5265V10.5037C6.8985 10.5622 6.94292 10.3845 6.93666 10.3301C7.2365 10.7972 7.66384 10.8846 8.07817 10.7503C8.07658 10.7944 8.07885 10.8337 8.05906 10.901L8.07817 10.8964C8.09551 10.8954 8.10263 10.8541 8.11399 10.8188C8.1017 10.8107 8.09864 10.7916 8.0925 10.7777L8.09727 10.764C8.32647 11.1586 8.89578 10.9737 8.96653 11.006C8.95778 11.0271 8.97149 11.084 8.98086 11.1339L8.99041 11.1476C9.00156 11.1248 9.00315 11.0928 8.99519 11.0517L8.97609 11.0152L8.9928 11.0243C9.18732 11.1624 9.45341 11.1532 9.67818 10.9786V10.9787Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3675",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35708 11.2939C8.48762 11.3522 8.62409 11.4005 8.7726 11.4287C8.7026 12.2642 8.25995 13.2196 7.79349 13.5022L7.80543 13.267C7.69123 13.0844 7.60078 12.7917 7.57617 12.1937L7.61438 12.1571C7.62507 12.5737 7.67226 12.9564 7.81737 13.2487C8.03918 13.0893 8.5237 12.558 8.59827 11.536C8.60238 11.4735 8.58453 11.4344 8.54812 11.415C8.46113 11.3691 8.40886 11.3314 8.35708 11.2939Z",
    fill: "#C1C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3677",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66992 14.829C7.17397 14.9576 7.50767 14.0276 7.6996 13.4014C7.6115 13.2337 7.4857 13.0597 7.47709 12.2988L7.43411 12.3399C7.38077 13.3152 7.3713 14.3919 6.66992 14.829Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3679",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91253 10.5811L6.94307 10.6101C6.9051 10.7944 6.64373 11.4631 6.96682 12.1151C6.7861 11.8612 6.63517 11.4594 6.91253 10.5811Z",
    fill: "#DFDDE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3681",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63782 10.9912L6.53988 11.1398L5.46929 15.2961L6.60405 11.8341C6.66036 12.0358 6.73122 12.2452 7.0262 12.5737C6.60969 13.9864 5.94903 15.248 5.38148 15.5804L5.43552 15.4092C5.19374 14.7092 5.38734 13.2387 5.80026 11.7598C5.53663 12.5704 4.99301 14.3434 5.33758 15.6352L5.2295 15.955C6.35292 15.2211 7.01374 13.3823 7.26261 12.4445C7.20167 12.4914 7.1332 12.5168 7.06335 12.5381C6.71069 12.2362 6.54055 11.7492 6.63782 10.9912Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3683",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96331 9.82715C5.99142 9.95455 6.14824 10.1046 6.22599 10.2337C6.2677 10.3004 6.31442 10.3264 6.37405 10.2474L6.42182 10.1743C6.53907 10.3003 6.69874 10.3669 6.93287 10.3295L6.65107 10.9507C6.32424 11.5565 5.88903 11.6873 5.45703 11.8322L5.59076 11.5947C6.15315 11.5433 6.55511 11.013 6.7657 10.5214C6.6253 10.4913 6.48998 10.4387 6.33165 10.34L5.66718 11.444L6.10659 10.3295C6.19511 10.1543 5.96258 10.0169 5.96331 9.82715Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3685",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6944 11.7598C5.61572 11.7911 5.5337 11.8193 5.44604 11.842C4.72331 13.3912 4.31788 14.7739 3.0293 15.2061C4.19893 15.4183 4.98513 13.6264 5.26932 13.0888C5.47813 12.6009 5.60271 12.1467 5.6944 11.7598Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3687",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8572 9.87012C5.72571 10.0209 5.27862 10.6187 5.56001 11.6173L5.58365 11.5882C5.38226 10.926 5.5919 10.1879 5.8572 9.87012Z",
    fill: "#E0DEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3689",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37538 10.752C5.33767 11.0113 5.35164 11.215 5.36343 11.4211C4.48675 12.9059 3.02267 14.2764 2.17773 14.3326C3.25556 12.952 4.33338 11.5253 5.4112 10.1217C5.48045 10.0934 5.54971 10.0479 5.61896 10.0029C5.50586 10.1625 5.45361 10.2929 5.4303 10.4094L2.46669 14.0426C3.45711 13.9642 5.08011 11.7202 5.32284 11.1151C5.3246 10.9338 5.3485 10.8372 5.37538 10.752Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3691",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35689 14.0952L2.42615 14.013C2.3408 12.6112 4.00156 10.9444 4.44885 10.4209C4.37463 10.5726 2.25775 12.3509 2.35689 14.0952Z",
    fill: "#DFDCE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3693",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.15234 11.5854C1.40098 11.958 1.81927 12.1911 3.38759 11.2794C3.70122 10.9488 4.01486 10.609 4.32849 10.3249L4.25207 10.3203C3.72392 10.5311 2.36058 11.897 1.15234 11.5854Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3695",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23246 8.95508C5.03163 9.03479 4.25513 9.30358 4.17693 10.138L4.00977 10.2271C5.06574 10.5633 5.87027 9.80049 6.03008 9.65844C5.86538 9.55753 5.69744 9.47518 5.55724 9.23369L5.41873 9.2976C5.07781 9.56854 4.66666 9.82999 4.27007 10.0832L5.49993 9.48487C5.57124 9.56128 5.65303 9.64021 5.82471 9.74063C5.07949 10.2302 4.49699 10.2058 4.21275 10.1357C4.25391 9.65328 4.55501 9.24281 5.23246 8.95508Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3697",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04424 9.94824C4.02114 10.0501 3.99413 10.1557 3.99696 10.2328C3.6607 10.3596 3.28961 10.4605 2.87233 10.527C2.8487 10.5334 2.73865 10.5739 2.69671 10.4979C2.64873 10.4683 2.59496 10.4609 2.53798 10.4656C2.52823 10.4407 2.47544 10.4517 2.46875 10.4284C3.49057 10.259 3.95688 10.0247 4.04424 9.94824Z",
    fill: "#CECAD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3699",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89839 9.22755C2.62909 9.35297 1.50761 9.92295 1.31445 10.4677C1.86072 10.6259 2.27107 10.4876 2.51845 10.4653C2.50715 10.4503 2.46119 10.4532 2.45597 10.4289C2.04814 10.4852 1.5613 10.5115 1.4259 10.4354L1.52722 10.3869C1.55875 9.92467 2.71489 9.34595 2.89839 9.22754V9.22755Z",
    fill: "#DFDDE1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3701",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5918 10.371C3.41889 9.72406 4.30472 9.20285 5.27976 8.88867V8.92098C5.20179 8.96826 4.56142 9.11184 4.31049 9.4603L1.5918 10.371Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3703",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96154 8.98549C4.83503 9.0362 4.71214 9.07659 4.57991 9.14371C3.9832 9.06079 3.88612 8.91837 3.6309 8.8014L3.68156 8.78201C3.77612 8.84769 3.89307 8.8991 4.00578 8.95319C4.18067 9.00963 4.22334 8.94213 4.04968 8.88214C3.84016 8.8184 3.70907 8.73246 3.59375 8.64961C3.79939 8.26872 4.28362 8.08739 4.34688 8.05859C4.0785 8.22548 3.76886 8.37323 3.68831 8.627C4.10505 8.56796 4.54687 8.49815 5.08987 8.38478C5.13073 8.45376 5.17056 8.52192 5.24861 8.62052L5.2351 8.6367L5.15404 8.54305L3.69844 8.64961C4.10227 8.91379 4.53311 8.93895 4.96154 8.98549Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3705",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22266 8.45312C1.3921 8.9913 2.80128 8.85424 3.63462 8.79839L3.6776 8.78467C3.61005 8.73969 3.55108 8.69474 3.51521 8.64975C3.16859 8.58015 1.5936 8.89704 1.22266 8.45312Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3707",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.87711 8.15786L3.89383 8.17155C3.79512 8.25114 3.69641 8.32024 3.59771 8.43415C2.29223 8.43696 1.47051 7.93956 1.23828 7.65088C1.56113 7.40135 1.96863 7.31368 2.39889 7.26953C2.02904 7.37453 1.596 7.4358 1.39828 7.66004H1.30515C1.91129 8.30762 3.52802 8.59634 3.87711 8.15786Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3709",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48047 7.68066C2.34838 7.79732 3.195 7.89877 4.08587 8.0319C4.20632 7.93078 4.4224 7.86465 4.7593 7.8426C4.64498 7.83967 4.55031 7.82826 4.37005 7.85398C3.37698 7.86753 2.43909 7.74935 1.48047 7.68066Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3711",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20102 7.55549C5.1197 7.6368 5.07649 7.75456 5.0458 7.88431C4.0915 7.58664 3.93614 7.01501 3.9043 6.95717C4.47771 6.5764 4.82329 6.7182 5.29894 6.70826C4.28806 6.66329 4.02222 6.91632 3.97833 6.96629C4.35784 7.06572 4.62619 7.15776 5.43983 7.28599C5.36207 7.3388 5.31311 7.38769 5.27983 7.43444C4.96551 7.31174 4.38483 7.14142 3.97116 6.98687C4.03644 7.25047 4.46312 7.64733 4.82132 7.74957C4.9214 7.77494 5.03073 7.82238 5.06968 7.70162C5.08487 7.65186 5.16402 7.57393 5.20102 7.55549Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3713",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57031 6.35645C1.75034 6.53129 2.44837 7.10828 3.71959 6.96388C3.76814 7.08258 3.8167 7.12615 3.86526 7.17397C3.52785 7.12483 3.18927 7.0891 2.84555 7.11233C2.28693 6.95159 1.77679 6.75772 1.57031 6.35645Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3715",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16474 6.60778C4.18457 6.61929 4.20331 6.63183 4.22922 6.63748C4.02109 6.71637 3.86027 6.80218 3.73489 6.89324C3.0938 6.70333 2.18414 6.2511 1.85547 5.68067C2.25241 5.51143 2.92597 5.58995 3.31698 5.68067C2.88312 5.67684 2.36495 5.59238 2.10622 5.75601L1.91039 5.68979C1.98837 5.93342 3.35225 7.07032 4.16474 6.60778Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3717",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17578 5.78809C2.99034 6.06031 3.76347 6.32951 4.41341 6.58964C4.61615 6.54257 4.81403 6.55577 5.01043 6.58734C4.96528 6.54484 4.91826 6.50771 4.87909 6.44805L4.86237 6.4549L4.94357 6.55768C3.83885 6.1975 3.02282 6.0016 2.17578 5.78809V5.78809Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3719",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73782 6.09616C4.67592 5.9841 4.61694 5.8692 4.61125 5.70338C4.30551 5.84081 2.90662 5.26176 2.57422 4.53418C2.59699 5.17483 3.79131 5.67669 4.73782 6.09616Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3721",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.54676 6.49617C5.50473 6.54056 5.46901 6.59399 5.41541 6.6218C5.38819 6.63855 5.36304 6.63541 5.33899 6.6218C4.84607 6.31954 4.74709 5.79536 4.75869 5.68781C5.13787 5.62621 5.66801 5.63454 6.39691 6.06688C6.23724 6.03441 5.69805 5.65492 4.83511 5.72432C4.81913 6.00912 5.04615 6.55405 5.54676 6.49617Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3723",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90234 5.77148L5.77638 6.38119C5.88942 6.38676 6.00245 6.38383 6.11549 6.43598C6.12173 6.41449 6.13237 6.38668 6.15131 6.34695C5.66927 6.1551 5.3162 5.96329 4.90234 5.77148Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3725",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92969 3.8252L3.16272 3.95759C3.13247 4.46312 4.06995 5.44621 5.11477 5.5239C4.94394 5.54057 4.75441 5.53632 4.61832 5.59173C4.12478 5.29933 3.79207 4.988 3.51733 4.71653C3.45943 4.72482 3.41442 4.58652 3.31807 4.62935C3.05254 4.30123 2.94736 4.0439 2.92969 3.8252Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3727",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45292 4.21551C4.10364 4.08596 3.78651 3.93743 3.17969 3.96037C4.12131 4.61319 4.63552 5.02453 5.32762 5.53637C5.64368 5.58168 5.9488 5.71593 6.25637 5.83026C6.21675 5.74951 6.18569 5.66877 6.16856 5.58803C6.17352 5.65586 6.17205 5.72369 6.21584 5.79147C5.80463 5.67835 4.11317 4.52808 3.28438 4.01524C3.59668 3.9213 4.03819 4.09627 4.45292 4.21551Z",
    fill: "#C4BECA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3729",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93546 4.24807C4.55553 3.93249 4.13328 3.57355 4.03711 3.06934C4.48034 3.11963 5.34571 3.40526 6.01618 3.86702C5.39163 3.52441 4.80214 3.26771 4.3208 3.276C4.28112 3.69357 4.68311 3.96867 4.93546 4.24807Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3731",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35034 3.28906L4.33008 3.30524C4.97119 3.75796 5.43543 4.18955 5.94103 4.6261C6.08415 4.74088 6.06376 4.86461 6.0795 4.98781C6.13165 4.9296 6.06347 4.73127 6.17462 4.71056C6.27933 4.69137 6.68047 4.89003 6.70429 4.85863C5.75841 4.45765 5.12905 3.81712 4.35034 3.28906Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3733",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36401 5.71059C6.27324 5.57106 6.13328 5.14066 6.22554 4.85156C7.4429 5.10311 7.64726 6.01887 7.66763 6.20148C7.48819 5.53764 6.82602 4.93511 6.37077 5.01304C6.64938 5.25795 6.98927 5.76031 7.20157 5.97543C7.10096 5.98029 7.00023 5.98508 6.93477 6.01095C6.76406 5.99275 6.68526 6.02547 6.59704 6.05295C6.50305 5.94889 6.46897 5.8703 6.41129 5.78168C6.53437 5.94778 6.71239 5.92249 6.89762 5.87208C6.71074 5.54626 6.52387 5.31179 6.33699 5.03566C6.24456 5.1022 6.33195 5.44963 6.36401 5.71059Z",
    fill: "#E0DEE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3735",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85352 4.4707C8.92435 5.78484 9.08073 7.94485 7.61678 7.59041C9.37295 7.38866 7.31446 4.89401 6.85352 4.4707Z",
    fill: "#DFDDE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3737",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94922 6.01811C7.11948 5.94991 7.57618 5.9575 7.59639 6.63013L7.44594 6.73744C7.44903 6.55326 7.4796 6.13768 6.94922 6.01811Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3739",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44531 6.74927L7.60293 6.63965C8.35661 6.91389 7.98694 7.69275 7.46203 7.5691C8.089 7.50779 7.95374 6.74362 7.44531 6.74927Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3741",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.875 1.69867C9.9775 1.8696 9.69295 2.38264 10.1831 2.30557C10.3492 2.40553 10.4982 2.35128 10.5728 2.35169C10.8975 2.24352 10.8881 2.0293 10.9087 1.97196C10.6268 1.59267 10.9427 1.52031 10.9773 1.49634C11.1517 1.51664 11.2413 1.82417 11.007 1.92224C11.0256 1.93644 11.054 1.93408 11.0924 1.91515C11.0889 2.4078 11.4549 2.44213 11.7085 2.36234C12.2081 2.49292 11.9659 1.94027 12.2021 1.52831C11.9339 1.97976 12.1068 2.39019 11.7159 2.3375C11.8165 2.10444 11.5508 1.92286 11.6825 1.67028C11.4788 1.837 11.8173 2.14524 11.6825 2.30557C11.5446 2.42101 11.4109 2.32488 11.4079 2.27363C11.3515 2.10641 11.751 1.90335 11.5118 1.59573C11.5938 1.76224 11.5654 1.83717 11.5215 1.94304C11.4776 2.0489 11.3085 2.14487 11.3856 2.35524C11.2105 2.32211 11.1196 2.1235 11.1682 1.9668C11.216 1.81233 11.298 1.5534 10.9922 1.46973C10.606 1.58071 10.8025 1.87298 10.8491 1.92505C10.9439 2.02324 10.77 2.31955 10.5524 2.31799C10.652 2.17251 10.5339 2.14314 10.3872 1.9116C10.3765 2.03467 10.6797 2.2009 10.506 2.29847C10.4169 2.36655 10.2907 2.32653 10.2387 2.27718C10.1404 2.17028 10.3769 2.04568 10.3334 1.84063C10.2699 2.14132 10.1785 2.12341 10.1905 2.26654C10.0767 2.29748 9.95794 2.33676 9.92092 2.12911C9.92333 1.84389 9.91741 1.66863 9.875 1.69867Z",
    fill: "#DFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3743",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8846 2.8605L11.8901 2.8905C11.2913 2.92722 10.6814 2.81824 10.0938 2.80576V2.7793C10.6885 2.79321 11.1588 2.89259 11.8846 2.8605Z",
    fill: "#DFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3745",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9608 2.95898L10.959 2.98218C11.3029 3.03388 11.6473 3.08617 11.9333 3.05895V3.03397C11.5884 3.07526 11.2773 3.00866 10.9608 2.95898Z",
    fill: "#DFA12F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3747",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1397 2.48621C10.0447 2.5153 10.0894 2.64864 10.1378 2.6479C10.2473 2.6531 10.3568 2.66806 10.4663 2.65145C10.5284 2.62344 10.5488 2.51831 10.4793 2.47556C10.3642 2.46201 10.2499 2.46213 10.1397 2.48621ZM10.1192 2.46845C10.3082 2.43375 10.4805 2.45602 10.5776 2.47378C10.6646 2.49592 10.6649 2.64112 10.5776 2.67099C10.4788 2.67971 10.2662 2.67756 10.1211 2.66566C10.0256 2.58994 10.0752 2.49836 10.1192 2.46845Z",
    fill: "#E1A02F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3749",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7992 2.63029C11.0459 2.66124 11.2544 2.67956 11.2019 2.49543C11.1316 2.49634 10.6568 2.39447 10.7992 2.63029ZM10.7918 2.65513C10.7584 2.62163 10.7123 2.54922 10.8029 2.45994C10.9407 2.45062 11.0815 2.45866 11.2242 2.47768C11.3553 2.5295 11.3436 2.64119 11.2353 2.68884C11.0039 2.68863 10.8807 2.67415 10.7918 2.65513H10.7918Z",
    fill: "#E1A02F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3751",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4638 2.66465C11.707 2.71465 11.9114 2.75801 11.8748 2.57037C11.8047 2.56579 11.3419 2.41854 11.4638 2.66465ZM11.4543 2.68882C11.4239 2.65285 11.3841 2.57709 11.482 2.49512C11.8311 2.51236 11.7725 2.51645 11.9003 2.54553C12.0266 2.60738 12.0054 2.71779 11.8935 2.7569C11.5907 2.76305 11.5384 2.71564 11.4543 2.68882Z",
    fill: "#E1A02F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3753",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03019 6.33301L6.64258 7.42502C6.75047 7.42312 6.84274 7.43025 7.03019 7.39313C7.20525 7.04928 7.24141 6.56232 7.03019 6.33301Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3755",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34232 8.46251L6.64202 7.42752C6.62497 7.40581 6.46541 7.85639 6.44336 7.99555C6.52961 8.22243 6.94302 8.4569 7.34232 8.46251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3757",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2282 7.66079C7.4735 7.57677 7.52077 7.43547 7.5241 7.35059L7.03125 7.39241C7.10123 7.47656 7.1728 7.56371 7.2282 7.66079Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3759",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40966 6.87759C6.31061 6.81463 5.98911 6.79257 5.92188 6.84834L6.33344 7.21252C6.35004 7.10599 6.37321 6.9828 6.40966 6.87759Z",
    fill: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3761",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.48047 7.99861L6.63475 7.42987C6.66088 7.41922 6.49645 7.86576 6.44271 7.99676C6.30554 8.06421 5.73324 8.19484 5.48047 7.99861Z",
    fill: "#C3BDC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61122_4991",
    x1: 6.42347,
    y1: 8.0839,
    x2: 8.62843,
    y2: 9.9084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BDC9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61122_4991",
    x1: 13.0452,
    y1: 12.3728,
    x2: 6.26123,
    y2: 8.7018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BDC9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61122_4991",
    x1: 16.6463,
    y1: 7.23526,
    x2: 12.6452,
    y2: 10.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3BDC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3BDC9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61122_4991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 24,
    fill: "white",
    transform: "translate(0.333984)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoland);
export default __webpack_public_path__ + "static/media/poland.c41bf53e27dde38ebcbdf7f1cb2488ad.svg";
export { ForwardRef as ReactComponent };